import React from 'react';
import {Box, Chip} from '@mui/material';
import {CalendarMonthOutlined, ContentCopyOutlined} from '@mui/icons-material';

const CardViewAdFooter = ({index, item, activityIndicatorCircle, inactivityIndicatorCircle}) => {
// Calculate the days since publication from an ISO-8601 timestamp, e.g. "2025-12-04T08:25:23.050+00:00"
const calculateDaysSincePublicationFromCreatedAt = (createdAt) => {
    if (!createdAt) return 0;

    const createdDate = new Date(createdAt);
    if (Number.isNaN(createdDate.getTime())) return 0;

    const now = new Date();
    const timeDifferenceMs = now.getTime() - createdDate.getTime();
    const daysDifference = Math.floor(timeDifferenceMs / (1000 * 60 * 60 * 24));
    return Math.max(0, daysDifference);
};

// Prefer createdAt (ISO string); fall back to legacy startDate (unix seconds) if present
const daysSincePublication = item?.createdAt
    ? calculateDaysSincePublicationFromCreatedAt(item.createdAt)
    : (typeof item?.startDate === 'number'
        ? Math.max(0, Math.floor((Date.now() - item.startDate * 1000) / (1000 * 60 * 60 * 24)))
        : 0);
  
        return (
            <div className="card-footer">
                {
                    item?.duplicates >= 1 && (
                        <div className={"card-footer-items"}
                             id="duplicados">
                            <span>{item?.duplicates} anuncios</span>
                        </div>
                    )
                }

            </div>);
    }
;

export default CardViewAdFooter;